/* eslint-disable camelcase */
import { Routes } from '../enum/routes.enum';
import backgroundDefault from './backgrounds/background-default.jpg';
import login from './backgrounds/login-new.jpg';

export const imgResolver = (pathname: string) => {
  if (pathname.includes(Routes.Login)) return login;
  return backgroundDefault;
};
